/*=========================================================================================
  File Name: getters.js
  namespace: quizzes
  Description: Vuex Store - Quiz getters
==========================================================================================*/

const getters = {
  getCurrentQuiz: state => {
    return state.quiz
  },
  getCurrentQuestions: state => {
    return state.questions
  },
  getCurrentAnswers: state => {
    return state.answers
  },
  getQuizList: state => {
    return {
      results: state.results,
      count: state.count
    }
  },
  getQuizEntries: state => {
    return state.quizList
  }
}

export default getters
